/*
 * Lens Type Required
 * Shoppers must pick "Prescription" or "Standard (No Prescription)" before a frame
 * can be added to the cart or sent through the "Select Lens" flow.
 * Acts on any product whose option is named "Lens Type", or whose option choices
 * include the word "Prescription" (so future products are covered even if the
 * option is named differently). Products without such an option are untouched.
 * To turn it off, remove the lens-type-required.js <script> tag from
 * snippets/product-variant-picker.liquid.
 */
(function () {
  if (window.__lensTypeRequiredLoaded) return;
  window.__lensTypeRequiredLoaded = true;

  var OPTION_LABEL = 'lens type';
  var CHOICE_KEYWORD = /prescription/i;
  var FALLBACK_MESSAGE = 'Please choose a lens type: Prescription or Standard (No Prescription).';
  var chosen = {};
  var scheduled = false;

  var style = document.createElement('style');
  style.textContent =
    '.lens-type-required__msg{flex-basis:100%;width:100%;margin:.8rem 0 0;color:#b3261e;font-size:1.4rem;font-weight:600;line-height:1.4;}' +
    '.lens-type-required__flash{animation:lensTypeFlash .9s ease 2;border-radius:.8rem;}' +
    '@keyframes lensTypeFlash{0%,100%{box-shadow:none;}50%{box-shadow:0 0 0 3px rgba(179,38,30,.45);}}' +
    '@media (prefers-reduced-motion:reduce){.lens-type-required__flash{animation:none;box-shadow:0 0 0 3px rgba(179,38,30,.45);}}' +
    '.lens-type-required__locked{opacity:.5;cursor:not-allowed;}';
  document.head.appendChild(style);

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function radiosIn(fieldset) {
    return fieldset.querySelectorAll('input[type="radio"]');
  }

  function isLensFieldset(fieldset) {
    var legend = fieldset.querySelector('legend');
    if (legend && legend.textContent.trim().toLowerCase().indexOf(OPTION_LABEL) === 0) return true;
    var radios = radiosIn(fieldset);
    if (radios.length < 2) return false;
    for (var i = 0; i < radios.length; i++) {
      if (CHOICE_KEYWORD.test(radios[i].value || '')) return true;
    }
    return false;
  }

  function messageFor(fieldset) {
    var names = [];
    var radios = radiosIn(fieldset);
    for (var i = 0; i < radios.length; i++) {
      var name = (radios[i].value || '').trim();
      if (name && names.indexOf(name) === -1) names.push(name);
    }
    if (names.length < 2) return FALLBACK_MESSAGE;
    var last = names.pop();
    var list = names.length > 1 ? names.join(', ') + ', or ' + last : names[0] + ' or ' + last;
    return 'Please choose a lens type: ' + list + '.';
  }

  function findLensFieldset(picker) {
    var sets = picker.querySelectorAll('fieldset');
    for (var i = 0; i < sets.length; i++) {
      if (isLensFieldset(sets[i])) return sets[i];
    }
    return null;
  }

  function scopeFor(el) {
    return el.closest('product-info') || el.closest('.product') || document;
  }

  function buttonsFor(sectionId, picker) {
    var list = [];
    var submit = document.getElementById('ProductSubmitButton-' + sectionId);
    if (submit) list.push(submit);
    Array.prototype.forEach.call(scopeFor(picker).querySelectorAll('.customLens'), function (btn) {
      list.push(btn);
    });
    return list;
  }

  function setMessage(fieldset, show) {
    var msg = fieldset.querySelector('.lens-type-required__msg');
    if (show && !msg) {
      msg = document.createElement('p');
      msg.className = 'lens-type-required__msg';
      msg.setAttribute('role', 'alert');
      msg.textContent = messageFor(fieldset);
      fieldset.appendChild(msg);
    } else if (!show && msg) {
      msg.parentNode.removeChild(msg);
    }
  }

  function lock(btn) {
    if (btn.getAttribute('data-lens-locked') !== 'true') btn.setAttribute('data-lens-locked', 'true');
    if (!btn.disabled) btn.disabled = true;
    if (!btn.classList.contains('lens-type-required__locked')) btn.classList.add('lens-type-required__locked');
  }

  function unlock(btn) {
    if (btn.getAttribute('data-lens-locked') !== 'true') return;
    btn.removeAttribute('data-lens-locked');
    btn.classList.remove('lens-type-required__locked');
    btn.disabled = false;
  }

  function apply() {
    scheduled = false;
    Array.prototype.forEach.call(document.querySelectorAll('variant-selects'), function (picker) {
      var fieldset = findLensFieldset(picker);
      if (!fieldset) return;
      var sectionId = picker.getAttribute('data-section');
      var buttons = buttonsFor(sectionId, picker);
      if (chosen[sectionId]) {
        setMessage(fieldset, false);
        buttons.forEach(unlock);
        return;
      }
      Array.prototype.forEach.call(radiosIn(fieldset), function (input) {
        if (input.getAttribute('autocomplete') !== 'off') input.setAttribute('autocomplete', 'off');
        if (input.checked) input.checked = false;
      });
      setMessage(fieldset, true);
      buttons.forEach(lock);
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(apply);
  }

  function remind(sectionId) {
    var picker = document.querySelector('variant-selects[data-section="' + sectionId + '"]');
    var fieldset = picker && findLensFieldset(picker);
    if (!fieldset) return;
    setMessage(fieldset, true);
    fieldset.classList.remove('lens-type-required__flash');
    void fieldset.offsetWidth;
    fieldset.classList.add('lens-type-required__flash');
    if (fieldset.scrollIntoView) {
      fieldset.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'center' });
    }
  }

  function lensRequiredFor(sectionId) {
    if (!sectionId || chosen[sectionId]) return false;
    var picker = document.querySelector('variant-selects[data-section="' + sectionId + '"]');
    return !!(picker && findLensFieldset(picker));
  }

  // Shopper picked a lens type: remember it for this product.
  // Listens to both "change" and "click" so a lens type the browser restored as
  // already selected still counts once the shopper clicks it.
  function onLensPick(event) {
    var input = event.target;
    if (!input || input.type !== 'radio' || !input.closest) return;
    var fieldset = input.closest('fieldset');
    if (!fieldset || !isLensFieldset(fieldset)) return;
    var picker = input.closest('variant-selects');
    if (!picker) return;
    chosen[picker.getAttribute('data-section')] = true;
    apply();
  }
  document.addEventListener('change', onLensPick, true);
  document.addEventListener('click', onLensPick, true);

  // Block "Add to cart" until a lens type is chosen.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.id || form.id.indexOf('product-form-') !== 0) return;
      var sectionId = form.id.slice('product-form-'.length);
      if (!lensRequiredFor(sectionId)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      remind(sectionId);
    },
    true
  );

  // Block the "Select Lens" prescription flow until a lens type is chosen.
  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target && event.target.closest ? event.target.closest('.customLens') : null;
      if (!btn) return;
      var picker = scopeFor(btn).querySelector('variant-selects');
      if (!picker) return;
      var sectionId = picker.getAttribute('data-section');
      if (!lensRequiredFor(sectionId)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      remind(sectionId);
    },
    true
  );

  // Re-apply after the theme re-draws the product form (for example, after a color change).
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['disabled']
  });

  // Re-check after the page fully loads and after back/forward navigation, when
  // browsers may restore an earlier selection without any visible page change.
  window.addEventListener('load', function () {
    apply();
    setTimeout(apply, 600);
    setTimeout(apply, 2000);
  });
  window.addEventListener('pageshow', apply);

  apply();
})();
